import {
	eventHandler
} from "../../../../../modules/vegas/js/util";

class CategoryNav {
	constructor(container) {
		this.container = container;
		this.data = JSON.parse(this.container.querySelector('[data-categories]').textContent);
		this.containerBacks = this.container.querySelector('.categories-backs');
		this.containerMain = this.container.querySelector('.categories-main');

		this.withLinkAll = this.container.dataset.withlinkall == true;
	}

	toCategory(id) {
		this.activeCategory = this.findCategoryById(id);
		this.renderCategories(this.activeCategory);
		this.changeEvent(this.activeCategory);
	}

	toBack(id) {
		this.activeCategory = id ? this.findCategoryById(id) : null;
		this.renderCategories(this.activeCategory);
		this.changeEvent(this.activeCategory);
	}

	toMain() {
		this.activeCategory = null;
		this.renderCategories(null);
	}

	findCategoryById(id) {
		return this.data.find(category => category.id === parseInt(id));
	}

	findChildrenByParentId(parentId) {
		return this.data.filter(category => category.parent_id === parentId);
	}

	findSiblingsByParentId(parentId) {
		return this.findChildrenByParentId(parentId);
	}

	findAncestors(id) {
		let ancestors = [];
		let category = this.findCategoryById(id);
		while (category && category.parent_id) {
			category = this.findCategoryById(category.parent_id);
			if (category) {
				ancestors.unshift(category);
			}
		}
		return ancestors;
	}

	changeEvent(category) {
		eventHandler.on(this.containerMain, 'change-category', {
			category: category
		});
	}

	renderCategories(activeCategory) {
		this.containerBacks.innerHTML = '';
		this.containerMain.innerHTML = '';

		// Если активная категория выбрана
		if (activeCategory) {
			// Кнопка возврата
			if (activeCategory.depth > 0 || activeCategory.depth === 0) {
				this.containerBacks.innerHTML += `
                    <li class="back back-to-main">
                        <a>Все категории</a>
                    </li>`;
			}

			// Предки
			let ancestors = this.findAncestors(activeCategory.id);
			ancestors.forEach(ancestor => {
				this.containerBacks.innerHTML += `
                    <li class="back" data-id="${ancestor.id}">
                        <a href="${ancestor.url}">${ancestor.title}</a>
                    </li>`;
			});

			// Активная категория
			if (activeCategory.has_child) {
				this.containerBacks.innerHTML += `
					<li class="active">
						<a>${activeCategory.title}</a>
					</li>`;
			}

			// Дочерние категории
			let children = this.findChildrenByParentId(activeCategory.id);
			if (children.length > 0) {
				children.forEach(child => {
					const hasChildClass = child.has_child > 0 ? 'has-child' : '';
					const productsCount = child.products_count;

					this.containerMain.innerHTML += `
						 <li class="category ${hasChildClass}" data-id="${child.id}">
							 <a href="${child.url}">
								${child.title}
								${productsCount > 0 ? `<span class="products-count">${productsCount}</span>` : ''}
							</a>
						 </li>`;
				});
			} else {
				// Если нет дочерних категорий, отображаем категории того же уровня
				let siblings = this.findSiblingsByParentId(activeCategory.parent_id);
				siblings.forEach(sibling => {
					const hasChildClass = sibling.has_child > 0 ? 'has-child' : '';
					const isActive = sibling.id === activeCategory.id ? 'active' : '';
					const productsCount = sibling.products_count;

					this.containerMain.innerHTML += `
						 <li class="category ${hasChildClass} ${isActive}" data-id="${sibling.id}">
							<a href="${sibling.url}">
								${sibling.title}
								${productsCount > 0 ? `<span class="products-count">${productsCount}</span>` : ''}
							</a>
						 </li>`;
				});
			}

			if (this.withLinkAll) {
				let allCategory = ancestors[0] || activeCategory;
				this.containerMain.innerHTML += `
					<li class="view-all" data-id="${allCategory.id}">
						<a href="${allCategory.url}">Смотреть все</a>
					</li>`;
			}
		} else {
			// Отображаем корневые категории, если активная категория не выбрана
			let rootCategories = this.findChildrenByParentId(null);
			rootCategories.forEach(category => {
				const hasChildClass = category.has_child > 0 ? 'has-child' : '';
				const productsCount = category.products_count;

				this.containerMain.innerHTML += `
					<li class="category category-first-level ${hasChildClass}" data-id="${category.id}">
                		 <a href="${category.url}">
                        	${category.title}
                        	${productsCount > 0 ? `<span class="products-count">${productsCount}</span>` : ''}
                    	</a>
            		</li>`;
			});
		}
	}
}

export default CategoryNav;
